<template>
  <div class="footer_cls">
    <div :class="'footer_relation_horizontal_cls'">
      <div class="footer_img_box">
        <img :src="qrCode" class="qr_code_img_cls" />
      </div>
      <div class="footer_relation_box">
        <div class="item_text1">{{ $t('navbar.contactUs') }}</div>
        <div class="item_text2">{{ $t('footer.phone') }}：{{ relationData.phone1 }}</div>
        <div class="item_text2">{{ $t('footer.phone') }}：{{ relationData.phone2 }}</div>
        <div class="item_text2">{{ $t('footer.address') }}：{{ relationData.address }}</div>
        <div class="item_text2">{{ $t('footer.email') }}：{{ relationData.email }}</div>
        <div class="item_text2">{{ $t('footer.facsimile') }}：{{ relationData.facsimile }}</div>
      </div>
      <div style="flex:0.5;"></div>
      <!-- 关于长城 -->
      <div class="footer_tab_box">
        <router-link to="/abort" key="abort">
          <div class="item_text1">{{ $t('navbar.abortGreatWall') }}</div>
        </router-link>
        <div class="line"></div>
        <router-link to="/abort?location=company-introduction-box" key="abort1">
          <div class="item_text2">{{ $t('navbar.companyIntroduction') }}</div>
        </router-link>
        <!-- <router-link to="/abort?location=development-history-box" key="abort2">
          <div class="item_text2">{{ $t('navbar.developmentHistory') }}</div>
        </router-link> -->
        <router-link to="/abort?location=honorary-qualifications-box" key="abort3">
          <div class="item_text2">{{ $t('navbar.honoraryQualifications') }}</div>
        </router-link>
        <router-link to="/abort?location=corporate-culture-box" key="abort4">
          <div class="item_text2">{{ $t('navbar.corporateCulture') }}</div>
        </router-link>
      </div>
      <!-- 产品服务 -->
      <div class="footer_tab_box">
        <router-link to="/services" key="services">
          <div class="item_text1">{{ $t('navbar.productServices') }}</div>
        </router-link>
        <div class="line"></div>
        <router-link to="/services?location=round-wire-products-box" key="services1">
          <div class="item_text2">{{ $t('navbar.roundWireProducts') }}</div>
        </router-link>
        <router-link to="/services?location=flat-wire-products-box" key="services2">
          <div class="item_text2">{{ $t('navbar.flatWireProducts') }}</div>
        </router-link>
        <router-link to="/services?location=application-area-box" key="services3">
          <div class="item_text2">{{ $t('navbar.applicationArea') }}</div>
        </router-link>
        <router-link to="/services?location=partners-box" key="services4">
          <div class="item_text2">{{ $t('navbar.partners') }}</div>
        </router-link>
      </div>
      <div class="footer_tab_box">
        <router-link to="/power" key="power">
          <div class="item_text1">{{ $t('navbar.greatWallPower') }}</div>
        </router-link>
        <div class="line"></div>
        <router-link to="/power?location=research-strength-box" key="power1">
          <div class="item_text2">{{ $t('navbar.researchStrength') }}</div>
        </router-link>
        <router-link to="/power?location=advanced-equipment-box" key="power2">
          <div class="item_text2">{{ $t('navbar.advancedEquipment') }}</div>
        </router-link>
        <router-link to="/power?location=quality-assurance-box" key="power3">
          <div class="item_text2">{{ $t('navbar.qualityAssurance') }}</div>
        </router-link>
        <router-link to="/power?location=authoritative-certification-box" key="power4">
          <div class="item_text2">{{ $t('navbar.authoritativeCertification') }}</div>
        </router-link>
      </div>
      <!-- 新闻资讯 -->
      <div class="footer_tab_box">
        <router-link to="/news" key="news">
          <div class="item_text1">{{ $t('navbar.newsInformation') }}</div>
        </router-link>
        <div class="line"></div>
        <router-link to="/news?tab=0" key="news0">
          <div class="item_text2">{{ $t('navbar.companyInformation') }}</div>
        </router-link>
        <router-link to="/news?tab=1" key="news1">
          <div class="item_text2">{{ $t('navbar.industryNews') }}</div>
        </router-link>
      </div>
      <!-- 加入我们 -->
      <div class="footer_tab_box">
        <router-link to="/contact" key="contact">
          <div class="item_text1">{{ $t('navbar.joinUs') }}</div>
        </router-link>
        <div class="line"></div>
        <router-link to="/contact?location=contact-us-box" key="contact1">
          <div class="item_text2">{{ $t('navbar.contactUs') }}</div>
        </router-link>
        <router-link to="/contact?location=recruitment-information-box" key="contact2">
          <div class="item_text2">{{ $t('navbar.recruitmentInformation') }}</div>
        </router-link>
      </div>
    </div>
    <!-- icp -->
    <div class="footer_logo_text_cls" @click="">
      <!-- <a target="_blank" href="https://beian.miit.gov.cn/#/Integrated/index" rel="noreferrer"> -->
      <a>
        浙ICP备17001311号-2&emsp;&emsp;&emsp;&emsp; © 2019长城科技 Copyright © 2019-2014 ICEDESIGN 长城科技
      </a>
    </div>
  </div>
</template>

<script>

import qrCode from '@/assets/images/qr_code.png'
export default {
  name: 'layout',
  data() {
    return {
      qrCode,
      path: this.$route.path,
      location: this.$route.query.location,
      relationData: {
        phone1: '0572-3956866',
        phone2: '0572-3957818',
        address: this.$t('footer.addressText'),
        email: 'ccxl@ccjt.com',
        facsimile: '0572-3952860'
      }
    }
  },
  watch: {
    $route: {
      handler(newRouter) {
        this.path = newRouter.path;
        this.location = newRouter.query.location;
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.footer_cls {
  width: 100%;
  background-color: #000;
  clear: both;
  padding-bottom: 6rem;
  height: 46rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  .footer_relation_horizontal_cls {
    color: #fff;
    padding-top: 6rem;
    padding-right: 0.5%;
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    align-content: center;

    .footer_img_box {
      .qr_code_img_cls {
        width: 23.7rem;
        margin-left: 6.5rem;
      }
    }

    .footer_relation_box {
      height: 23.7rem;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      margin-left: 3rem;
      text-align: left;
      cursor: default;

      .item_text1 {
        font-size: 2.3rem;
        font-family: "AdobeHeitiStd";
        color: #ffffff;
        line-height: 1;
      }

      .item_text2 {
        font-size: 2rem;
        font-family: "AdobeHeitiStd";
        color: #ffffff;
        line-height: 1;
        max-width: 35rem;
      }
    }

    .footer_tab_box {
      // width: auto;
      flex: 1;
      text-align: left;
      letter-spacing: 2px;

      .item_text1 {
        height: 2.6rem;
        font-size: 2.3rem;
        font-family: "AdobeHeitiStd";
        color: #ffffff;
        line-height: 2.6rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        word-break: break-all;
        padding-right: 1rem;
        &:hover {
          font-size: 2.6rem !important;
          color: #0089ff !important;
        }
      }

      .line {
        width: 7rem;
        height: 4px;
        background-color: #ffffff;
        margin-top: 2rem;
      }

      .item_text2 {
        height: 2.3rem;
        font-size: 2rem;
        color: #8a8a8a;
        margin-top: 2rem;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        /*! autoprefixer: off */
        -webkit-box-orient: vertical;
        /* autoprefixer: on */
        &:hover {
          font-size: 2.3rem !important;
          color: #0089ff !important;
        }
      }
    }
  }

  .footer_logo_text_cls {
    width: 100%;
    text-align: center;
    font-size: 2rem;
    font-family: "AdobeHeitiStd";
    color: #727272;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/Layout/components/FooterBox.vue